export default (state = [], action) => {
  switch (action.type) {
    case 'APPS_IN_PRIORITY_QUEUE':
      return action.payload;
    default:
      return state;
  }
};
